import { Skeleton, Stack, type StyleProp } from "@mantine/core";

interface SkeletonBarsProps {
  size?: StyleProp<React.CSSProperties["height"]>;
  count?: number;
}

export const SkeletonBars = ({ size = "2rem", count = 2 }: SkeletonBarsProps) => {
  return (
    <Stack>
      {[...Array(count).keys()].map((i) => (
        <Skeleton h={size} key={i} />
      ))}
    </Stack>
  );
};

export default SkeletonBars;
